import { callApi } from './ApiClient';

const zipcloud = (zip_code, dispatch) => {
  return callApi('GET', `/api/zipcloud/${zip_code}`, null, dispatch);
}

const postIpCheck = (type, dispatch) => {
  return callApi('POST', `/ip/check`, { type: type }, dispatch);
}

export const CommonApi = {
  zipcloud,
  postIpCheck,
};



// WEBPACK FOOTER //
// ./src/redux/api/CommonApi.js